// A Kubernetes namespace's name (a DNS-1123 label): up to 63 lowercase
// letters, digits and hyphens, starting and ending with a letter or digit.
const NAMESPACE_PATTERN = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;

/** Where Argo CD's install manifests put it, and so `argocd-rbac-cm`. */
export const DEFAULT_NAMESPACE = "argocd";

/** What to enter when {@link isNamespace} refuses a value. */
export const INVALID_NAMESPACE =
  "Enter the Kubernetes namespace Argo CD runs in, such as argocd: up to 63 lowercase letters, digits and hyphens, starting and ending with a letter or digit.";

/** Whether `namespace`, ignoring surrounding whitespace, can be a Kubernetes
 * namespace's name. */
export const isNamespace = (namespace: unknown): namespace is string =>
  typeof namespace === "string" && NAMESPACE_PATTERN.test(namespace.trim());

/** Whether `namespace` can fill the instance's optional namespace field:
 * blank, which stands for {@link DEFAULT_NAMESPACE}, or a namespace's name.
 * The install framework runs a field's validator on any string it's sent, so
 * a form that sends the field empty has to pass. */
export const isNamespaceOrBlank = (namespace: unknown): namespace is string =>
  (typeof namespace === "string" && namespace.trim() === "") ||
  isNamespace(namespace);

/** The namespace `argocd-rbac-cm` is in, for an instance that may have left
 * it out or blank: {@link DEFAULT_NAMESPACE} unless it names another. */
export const toNamespace = ({ namespace }: { namespace?: string }) =>
  namespace?.trim() || DEFAULT_NAMESPACE;
